import { render, staticRenderFns } from "./consent-logs-view.vue?vue&type=template&id=b713438e&scoped=true"
import script from "./consent-logs-view.vue?vue&type=script&lang=js"
export * from "./consent-logs-view.vue?vue&type=script&lang=js"
import style0 from "./consent-logs-view.vue?vue&type=style&index=0&id=b713438e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b713438e",
  null
  
)

export default component.exports